import * as React from "react"
import {IconSeeker, ImageSeeker, TabsSeeker} from "@ui-seeker/core";
import {Box, Skeleton} from "@mui/material";

import {TABS_OFFERS} from "../@constants";
import {customDashboardsPrimorTabID, customDashboardsPrimorIsLoadingOffers} from "../@signals";


export default function CustomDashboardsPrimorFlashOffersOffersTabs() {

	const ImageRetailerTitle = ({ name, siteID }) => {
		return <Box display='flex'>
			<ImageSeeker
				src={`/logos/website_ico_${siteID}.png`}
				width={16}
				height={16}
				sx={{ mr: 1 }}
			/>
			{name}
		</Box>
	}

    return <TabsSeeker
		showTabID={customDashboardsPrimorTabID.value}
		onChange={(_, newValue) => customDashboardsPrimorTabID.value = newValue || TABS_OFFERS.DRUNI}
		tabs={[{
			label: <ImageRetailerTitle name={'Druni'} siteID={16} />,
			value: TABS_OFFERS.DRUNI,
			icon: customDashboardsPrimorIsLoadingOffers.value ? <IconSeeker isSpin icon="spinner" /> : null,
		}, {
			label: <ImageRetailerTitle name={'Primor'} siteID={2} />,
			value: TABS_OFFERS.PRIMOR,
			icon: customDashboardsPrimorIsLoadingOffers.value ? <IconSeeker isSpin icon="spinner" /> : null,
		}]}
	/>
}